export * from './dealer.component';
export * from './view-dealer/view-dealer.component';
